import { useCallback, useEffect, useRef, useState } from 'react';

export const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
export const jsonHeaders = () => ({ 'Content-Type': 'application/json', ...authHeaders() });

// GET a dashboard endpoint. `interval` (ms) re-fetches quietly in the background.
export function useApi(path, { interval = 0 } = {}) {
  const [state, setState] = useState({ data: null, error: null, loading: true });
  const alive = useRef(true);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);

  const load = useCallback(async (silent) => {
    try {
      const r = await fetch(`${BASE}${path}`, { headers: authHeaders() });
      const j = await r.json().catch(() => null);
      if (!r.ok) throw new Error((j && j.message) || `HTTP ${r.status}`);
      if (alive.current) setState({ data: j, error: null, loading: false });
    } catch (e) {
      if (alive.current) setState(s => ({ data: silent ? s.data : null, error: e.message, loading: false }));
    }
  }, [path]);

  useEffect(() => {
    setState(s => ({ ...s, loading: true }));
    load(false);
    if (!interval) return undefined;
    const id = setInterval(() => load(true), interval);
    return () => clearInterval(id);
  }, [load, interval]);

  return { ...state, reload: () => load(true) };
}

export const fmtINR = v => `₹${Number(v || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
export const fmtDay = d => new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
